import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { SetupTab } from 'areas/shared/pages/setup'
import { ActionButton } from 'fw/components';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import ReviewPanel from 'areas/admin/certification/shared/ReviewPanel';
import VeteranOwnerInfoItem from './VeteranOwnerInfoItem'
import PointOfContactList from './PointOfContactList'
import { CommentsGrid, AdminAppIdHeader } from 'areas/shared/components'
import * as ReportManager from 'modules/reports/ReportManager';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import { QueueType } from 'areas/shared/consts';

class VeteranOwnerInfo extends SetupTab {
    initialForm() {
        return {
            rowVersion: null,
            veteranOwnerList: [],
            pointOfContactList: [],
            reviewComment: '',
            tooltips: []
        }
    }

    skipValidations() {
        return App.hasPrivilege("AdminSkipValidations");
    }

    updatePostData = (form, dirty) => {
        this.refs['_veteranOwnerList'].register(this._form);
        this.refs['_pointOfContactList'].register(this._form);
        
        if (this.state.form.showComplete)
            this.validateReviewStatus(form);
        this.setState({ form })

        if (dirty === true)
            this.dirt()
    }

    validateReviewStatus = (form) => {
        let canComplete=
            (
                this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
            ) ||
            this.state.form.veteranOwnerList.every((item) => { 
                let isValid = true;
                let veteranReviewDisabled = this.state.form.isRenewal && !item.fromRenewal;

                if(item.isOwnerVeteran && item.sF180)
                    isValid = (veteranReviewDisabled || item.sF180.validDocument) && isValid;
                if(item.isOwnerVeteran && item.citizenshipProof)
                    isValid = ((veteranReviewDisabled && !item.citizenshipProofMissingFromOriginalApp) || item.citizenshipProof.validDocument) && isValid;
                if(item.ownerResume)
                    isValid = (veteranReviewDisabled || item.ownerResume.validDocument) && isValid;
                if(item.isOwnerVeteran && item.veteranServiceConnectedDisabled && item.benefitVerificationLetter)
                    isValid = item.benefitVerificationLetter.validDocument && isValid;

                return isValid;
            });
        if (form.reviewStatus !== null && form.reviewStatus !== undefined && form.reviewStatus && !canComplete)
            form.reviewStatus = false;
    }

    beforeSave = (cb) => {
        this._ast.checkReviewStatus(cb);
    }

    addVeteranOwner = (order) => {
        let item = {
            veteranOwnerId: -Math.abs(Date.now() | 0),
            isOwnerVeteran: (order === 0) ? true : false,
            order: order,
            phones: [{
                phoneTypeCode: "MOBILE",
                number: "",
                extension: "",
				countryCode: "+1",
                phoneId: -Math.abs(Date.now() | 0)
            }],
            sF180: {validDocument: false},
            citizenshipProof: {validDocument: false},
            ownerResume: {validDocument: false},
            benefitVerificationLetter: {validDocument: false},     
        }

        let form = this.state.form
        form.veteranOwnerList = form.veteranOwnerList.concat(item)

        this.updatePostData(form)
    }

    onDeleteVeteranOwner = (index) => {
        let form = this.state.form

        form.veteranOwnerList.splice(index, 1)

        this.updatePostData(form, true)
    }
    
    onUpdateVeteranOwnerList = (index, item) => {
        let form = this.state.form

        form.veteranOwnerList[index] = item
        this.updatePostData(form, true)
    }

    addPointOfContact = (order) => {
        let item = {
            pointOfContactId: -Math.abs(Date.now() | 0),
            order: order
        }

        let form = this.state.form
        form.pointOfContactList = form.pointOfContactList.concat(item)

        this.updatePostData(form)
    }

    onDeletePointOfContact = (index) => {
        let form = this.state.form

        form.pointOfContactList.splice(index, 1)

        this.updatePostData(form, true)
    }
    
    onUpdatePointOfContactList = (index, item) => {
        let form = this.state.form

        form.pointOfContactList[index] = item
        this.updatePostData(form, true)
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminAppManagementEdit")
        }
    }

    urls() {
        return {
            get: API.Admin.url('/certification/getVeteranOwnerInfo'),
            save: API.Admin.url('/certification/saveVeteranOwnerInfo')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId,
            queueTypeCode: this.props.queueTypeCode
        }
    }

    saveRequest() {
        return {
            certificationId: this.state.form.certificationId,
            veteranOwnerList: this.state.form.veteranOwnerList,
            pointOfContactList: this.state.form.pointOfContactList,
            reviewStatus: this.state.form.reviewStatus,
            reviewQueueTypeCode: this.state.form.certificationQueueTypeCode,
            reviewComment: this.state.reviewComment
            //rowVersion: this.state.form.rowVersion
        }
    }

    isEnabled(data) {
        return !data.isReviewFinished;
    }

    ready = () => {
        if (this.state.form.veteranOwnerList.length === 0) {
            this.addVeteranOwner(0);
        }

        this.focusControl && this.focusControl.focus()
    }

    handlePrint = () => {
        const rq = Object.assign({
            reportType: 'VeteranOwnerInfoReport',
            format: 'PDF',
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        })

        ReportManager.execute(rq)
    }

    handleReviewStatus = (formReview) => {
        let form = this.state.form;
        form.reviewStatus = formReview.isReviewCompleted;

        this.updatePostData(form, true);
    };

    handleStepCommentSave = (formParam, callback) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        if (callback)
            callback();
        else
            this.handleSubmit();
    }

    handleAdminStepToolbar = () => {
        this.handleSubmit();
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                ref={(c) => { this._ast = c }}
                onCommentSave={this.handleStepCommentSave}
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'VI'}
                queueTypeCode={this.state.form.certificationQueueTypeCode}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }
    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={6}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3 style={{ marginTop: "0px", position: "relative" }}>
                                    <AdminAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.setupProps.daysOpen} certificationType={this.state.form.certificationType} certificationStatus={this.state.form.certificationStatus} />
                                </h3>
                                <hr />
                                <h3 style={{ marginTop: "0px" }}>
                                    Veteran Owner Information – <small>Please submit all required Veteran Owner Information</small>
                                    {this.renderAdminStepToolbar()}
                                    {this.state.form.allowPrinting &&
                                        <div className='pull-right'>
                                            <ActionButton id='btnPrint' onClick={this.handlePrint} icon='print' bsSize='sm'>
                                                Print
                                            </ActionButton>
                                        </div>}
                                </h3>
                                <hr />
                            </Col>
                        </Row>
                        <VeteranOwnerInfoItem
                            skipValidations={this.state.form.skipValidations}
                            veteranOwnerList={this.state.form.veteranOwnerList}
                            isRenewal={this.state.form.isRenewal}
                            addVeteranOwner={this.addVeteranOwner}
                            onDeleteVeteranOwner={this.onDeleteVeteranOwner}
                            onUpdateVeteranOwnerList={this.onUpdateVeteranOwnerList}
                            formSF180StorageToken={this.state.form.formSF180StorageToken}
                            formSF180fileName={this.state.form.formSF180fileName}
                            queueTypeCode={this.state.form.certificationQueueTypeCode}
                            ref={'_veteranOwnerList'}
                            tooltips = {this.state.tooltips}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3 style={{ marginTop: "0px" }}>Points of Contact</h3>
                                <hr />
                            </Col>
                        </Row>
                        <PointOfContactList
                            pointOfContactList={this.state.form.pointOfContactList}
                            addPointOfContact={this.addPointOfContact}
                            onDeletePointOfContact={this.onDeletePointOfContact}
                            onUpdatePointOfContactList={this.onUpdatePointOfContactList}
                            queueTypeCode={this.state.form.certificationQueueTypeCode} // Needed ?
                            ref={'_pointOfContactList'}
                            tooltips = {this.state.tooltips}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>&nbsp;</Col>
                </Row>
                {this.state.form.showReview ?
                    <React.Fragment>
                        <Row>
                            <CommentsGrid
                                ref={(c) => { this._commentsGrid = c }}
                                comments={this.state.form.comments}
                                documents={this.state.form.reviewDocuments}
                                certificationKey={this.props.selectedId}
                                reviewTypeCode={'VI'}
                                queueTypeCode={this.state.form.certificationQueueTypeCode}
                                enableExport={true}
                                entityId={this.state.form.vobId} // Only for this tab (Veteran Info) the EntityId is the CompanyId
                                readonly={!this.state.privileges.edit || !this.state.enabled}
                                onSave={this.handleCommentsGrid}
                                onCommentChange={this.handleCommentChange}
                            />
                        </Row>
                        {this.state.form.showComplete ?
                            <Row>
                                <ReviewPanel stepName="Veteran Owner"
                                    canComplete={
                                        (
                                            this.state.form.certificationQueueTypeCode !== QueueType.APPLICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.CERTIFICATION_REVIEW.code &&
                                            this.state.form.certificationQueueTypeCode !== QueueType.COMMITTEE_REVIEW.code
                                        ) ||
                                    this.state.form.veteranOwnerList.every((item) => { 
                                        let isValid = true;
                                        let veteranReviewDisabled = this.state.form.isRenewal && !item.fromRenewal;

                                        if(item.isOwnerVeteran && item.sF180)
                                            isValid = (veteranReviewDisabled || item.sF180.validDocument) && isValid;
                                        if(item.isOwnerVeteran && item.citizenshipProof)
                                            isValid = ((veteranReviewDisabled && !item.citizenshipProofMissingFromOriginalApp) || item.citizenshipProof.validDocument) && isValid;
                                        if(item.ownerResume)
                                            isValid = (veteranReviewDisabled || item.ownerResume.validDocument) && isValid;
                                        if(item.isOwnerVeteran && item.veteranServiceConnectedDisabled && item.benefitVerificationLetter)
                                            isValid = item.benefitVerificationLetter.validDocument && isValid;

                                        return isValid;
                                    })}
                                    onChange={this.handleReviewStatus}
                                    reviewStatus={this.state.form.reviewStatus} />
                            </Row>
                            : null}
                    </React.Fragment> 
                    : null}
            </React.Fragment>
        )
    }
}

export default VeteranOwnerInfo



// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/veteranOwnerInfo/VeteranOwnerInfo.js